const Months = [
	'Janvier',
	'Février',
	'Mars',
	'Avril',
	'Mai',
	'Juin',
	'Juillet',
	'Août',
	'Septembre',
	'Octobre',
	'Novembre',
	'Décembre'
]

export default Months



// WEBPACK FOOTER //
// ./src/common/components/MyPatrimonialLandscape/data/Months.js